import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { parseRecargasSummary, type RecargasSummary } from "@/lib/credits-plan";
import { useCreditsChanged } from "@/lib/credits-events";

export function useRecargasSummary(orgId: string | null, enabled: boolean) {
  const [result, setResult] = useState<{ orgId: string; summary: RecargasSummary | null } | null>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!orgId || !enabled) return;
    let cancelled = false;
    Promise.resolve(supabase.rpc("current_credit_plan_summary" as never)).then(({ data, error }) => {
      if (cancelled) return;
      if (error) console.error("[useRecargasSummary]", error.message);
      const summary = error ? null : parseRecargasSummary(data);
      setResult({ orgId, summary: summary && summary.organizationId === orgId ? summary : null });
    });
    return () => { cancelled = true; };
  }, [orgId, enabled, version]);

  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  useCreditsChanged(enabled ? orgId : null, refresh);
  const loaded = !!orgId && result?.orgId === orgId;
  return { summary: enabled && loaded ? result.summary : null, loading: enabled && !!orgId && !loaded, refresh };
}
